import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const formatDateTime = (recDate) => {
  const dateObj = new Date(recDate);
  const date = dateObj.toLocaleDateString("en-CA"); // Format: YYYY-MM-DD
  const time = dateObj.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return { date, time };
};

const AppointmentPage = () => {
  const { t } = useTranslation();
  const [appointments, setAppointments] = useState([]); // Changed state variable name to appointments
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const [newDate, setNewDate] = useState("");
  const [newTime, setNewTime] = useState("");
  const [warningMessage, setWarningMessage] = useState("");
  const navigate = useNavigate();
  const ID = localStorage.getItem("userID");
  const empDescriptions = {
    8: "Master Siewli",
    9: "Master Dennis",
    10: "Master Joey",
  };
  const [profiles, setProfiles] = useState([]);

  // Fetch appointments on component mount
  useEffect(() => {
    // Fetch profiles in parallel so descriptions and meet handlers can be dynamic
    const fetchProfiles = async () => {
      try {
        const resp = await fetch(
          "https://xianhefairy.com/LotusFairy_API/api/profile/GetAll",
        );
        if (resp.ok) {
          const data = await resp.json();
          setProfiles(data || []);
          console.log("Fetched profiles for account page:", data);
        }
      } catch (err) {
        console.error("Failed to fetch profiles:", err);
      }
    };

    fetchProfiles();
    const fetchAppointments = async () => {
      try {
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/Booking/getCheckCall?ID=${ID}`,
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setAppointments(data);
        console.log("Fetched appointments:", data);
      } catch (error) {
        console.error("Error fetching appointments:", error);
      }
    };

    fetchAppointments();
  }, []); // Empty dependency array means this runs once on mount

  const handleAppointmentClick = (appointmentId) => {
    setSelectedAppointment(
      appointmentId === selectedAppointment ? null : appointmentId,
    );
    console.log("Clicked appointment UID:", appointmentId);
    console.log("Updated selectedAppointment:", selectedAppointment);
  };

  const handleChangeAppointment = (appointment) => {
    setSelectedAppointment(appointment); // Store full appointment data
    setIsModalOpen(true);
  };

  const timeSlots = [
    { start: { hour: 10, minute: 0 }, end: { hour: 10, minute: 30 } },
    { start: { hour: 10, minute: 30 }, end: { hour: 11, minute: 0 } },
    { start: { hour: 11, minute: 0 }, end: { hour: 11, minute: 30 } },
    { start: { hour: 11, minute: 30 }, end: { hour: 12, minute: 0 } },
    { start: { hour: 12, minute: 0 }, end: { hour: 12, minute: 30 } },
    { start: { hour: 12, minute: 30 }, end: { hour: 13, minute: 0 } },
    { start: { hour: 13, minute: 0 }, end: { hour: 13, minute: 30 } },
    { start: { hour: 13, minute: 30 }, end: { hour: 14, minute: 0 } },
    { start: { hour: 14, minute: 0 }, end: { hour: 14, minute: 30 } },
    { start: { hour: 14, minute: 30 }, end: { hour: 15, minute: 0 } },
    { start: { hour: 15, minute: 0 }, end: { hour: 15, minute: 30 } },
    { start: { hour: 15, minute: 30 }, end: { hour: 16, minute: 0 } },
    { start: { hour: 16, minute: 0 }, end: { hour: 16, minute: 30 } },
    { start: { hour: 16, minute: 30 }, end: { hour: 17, minute: 0 } },
    { start: { hour: 17, minute: 0 }, end: { hour: 17, minute: 30 } },
    { start: { hour: 17, minute: 30 }, end: { hour: 18, minute: 0 } },
    { start: { hour: 18, minute: 0 }, end: { hour: 18, minute: 30 } },
    { start: { hour: 18, minute: 30 }, end: { hour: 19, minute: 0 } },
    { start: { hour: 19, minute: 0 }, end: { hour: 19, minute: 30 } },
    { start: { hour: 19, minute: 30 }, end: { hour: 20, minute: 0 } },
  ];

  // Slots are 30 minutes long (see timeSlots below); allow joining a few
  // minutes early but block access once the appointment's slot has passed.
  const MEET_EARLY_WINDOW_MINUTES = 10;
  const MEET_SESSION_DURATION_MINUTES = 30;

  const handleMeetNowClicklocked = (appointment) => {
    const currentDate = new Date();
    const appointmentDate = new Date(appointment.REC_DATE);
    const windowStart = new Date(
      appointmentDate.getTime() - MEET_EARLY_WINDOW_MINUTES * 60000,
    );
    const windowEnd = new Date(
      appointmentDate.getTime() + MEET_SESSION_DURATION_MINUTES * 60000,
    );

    // TESTING: appointment time restriction disabled. Uncomment before going live.
    if (currentDate < windowStart || currentDate > windowEnd) {
      setWarningMessage(
        t("upcomingConsultation.warningMessage1") ||
          "You cannot start the meeting until the appointment time.",
      );
      setIsWarningModalOpen(true);
      return;
    }

    const matched = profiles.find(
      (p) => Number(p.ID) === Number(appointment.EMP_ID),
    );
    const empCode = matched
      ? matched.EmpCode
      : appointment.EMP_ID === 8
        ? "MAS1"
        : appointment.EMP_ID === 9
          ? "MAS2"
          : appointment.EMP_ID === 10
            ? "MAS3"
            : null;
    if (empCode) {
      localStorage.setItem("empCode", empCode);
      localStorage.setItem("Emp_ID", String(appointment.EMP_ID));
      openWaitingLobby(empCode);
    }
    setSelectedAppointment(appointment);
    // setIsWarningModalOpen(true);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault(); // Prevent default form submission

  //   if (!selectedAppointment) {
  //     alert("No appointment selected. Please try again.");
  //     return;
  //   }

  //   if (!newTime) {
  //     alert("Please select a valid time.");
  //     return;
  //   }

  //   const formattedTime = convertTo24HourFormat(newTime);
  //   const schedDateTime = `${newDate}T${formattedTime}`;

  //   const requestBody = {
  //     UID: selectedAppointment.UID,
  //     BUID: "",
  //     FSMasterID: selectedAppointment.EMP_ID,
  //     CustomerID: ID,
  //     SchedDate: schedDateTime,
  //   };

  //   console.log("Request Body:", requestBody);

  //   try {
  //     const response = await fetch(
  //       "https://xianhefairy.com/LotusFairy_API/api/member/PostBookingSchedule",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestBody),
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(
  //         `Failed to update appointment. Status: ${response.status}`
  //       );
  //     }

  //     const result = await response.json();
  //     console.log("Appointment updated successfully:", result);

  //     alert("Appointment updated successfully!");
  //     handleModalClose();
  //   } catch (error) {
  //     console.error("Error updating appointment:", error);
  //     alert("Failed to update appointment. Please try again.");
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    if (!selectedAppointment) {
      alert("No appointment selected. Please try again.");
      return;
    }

    if (!newTime) {
      alert("Please select a valid time.");
      return;
    }

    const formattedTime = convertTo24HourFormat(newTime);
    const schedDateTime = `${newDate}T${formattedTime}`;

    const requestBody = {
      UID: selectedAppointment.UID,
      SchedDate: schedDateTime,
    };

    console.log("Request Body:", requestBody);

    try {
      const response = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/Booking/AppointmentUpdate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        },
      );

      if (!response.ok) {
        throw new Error(
          `Failed to update appointment. Status: ${response.status}`,
        );
      }

      const result = await response.json();
      console.log("Appointment updated successfully:", result);

      alert("Appointment updated successfully!");
      handleModalClose();

      // Refresh appointments after update
      const fetchAppointments = async () => {
        try {
          const response = await fetch(
            `https://xianhefairy.com/LotusFairy_API/api/Booking/getCheckCall?ID=${ID}`,
          );
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          setAppointments(data);
          console.log("Fetched appointments:", data);
        } catch (error) {
          console.error("Error fetching appointments:", error);
        }
      };
      fetchAppointments();
    } catch (error) {
      console.error("Error updating appointment:", error);
      alert("Failed to update appointment. Please try again.");
    }
  };

  const convertTo24HourFormat = (time12h) => {
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");

    if (modifier === "PM" && hours !== "12") {
      hours = String(parseInt(hours, 10) + 12);
    } else if (modifier === "AM" && hours === "12") {
      hours = "00";
    }

    return `${hours}:${minutes}:00`;
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setNewDate("");
    setNewTime("");
  };

  const handleWarningModalClose = () => {
    setIsWarningModalOpen(false);
  };

  // Use local date (YYYY-MM-DD) to avoid timezone shift issues when REC_DATE is midnight
  const today = new Date().toLocaleDateString("en-CA"); // Get today's local date in YYYY-MM-DD format

  // Separate today's and future appointments using local date strings
  const todaysAppointments = appointments.filter((a) => {
    if (!a || !a.REC_DATE) return false;
    try {
      return new Date(a.REC_DATE).toLocaleDateString("en-CA") === today;
    } catch (e) {
      return false;
    }
  });

  const futureAppointments = appointments.filter((a) => {
    if (!a || !a.REC_DATE) return false;
    try {
      return new Date(a.REC_DATE).toLocaleDateString("en-CA") > today;
    } catch (e) {
      return false;
    }
  });

  //waiting lobby
  const [isWaitingLobbyOpen, setIsWaitingLobbyOpen] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [waitingMessage, setWaitingMessage] = useState(
    "Waiting for Master to join...",
  );
  const waitingIntervalRef = useRef(null);

  const waitingLobby = async (EMP_ID) => {
    try {
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/Booking/getCall?employee=${EMP_ID}&ID=${ID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        console.log("this is data", data);
        return data;
      } else {
        console.log("error for pathing");
        return null;
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setIsWarningModalOpen(true);
      return null;
    }
  };

  const openWaitingLobby = (empId) => {
    setIsWaitingLobbyOpen(true);
    setIsWaiting(true);
    setWaitingMessage("Waiting for Master to join...");

    const checkMasterPresence = async () => {
      const data = await waitingLobby(empId);
      if (data && data.length > 0) {
        clearInterval(waitingIntervalRef.current);
        setIsWaitingLobbyOpen(false);
        // CHANNEL on the live-call record is the master's Zoom session name
        // (ZoomAppointment.jsx writes this via PostBooking when they join).
        navigate("/appointment", {
          state: {
            sessionName: data[0].CHANNEL || empId,
            isHost: false,
            userName: localStorage.getItem("username") || "Guest",
          },
        });
      }
    };

    waitingIntervalRef.current = setInterval(checkMasterPresence, 10000);
  };

  const cancelWaiting = () => {
    clearInterval(waitingIntervalRef.current);
    setIsWaitingLobbyOpen(false);
    setIsWaiting(false);
    setWaitingMessage("Waiting canceled.");
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>{t("upcomingConsultation.appointments")}</h1>
      <div style={styles.listContainer}>
        <ul>
          {/* Accessible Appointments (Today) */}
          {todaysAppointments.length > 0 && (
            <>
              <h3 style={{ color: "#DFBD69" }}>
                {todaysAppointments.length > 1
                  ? t("upcomingConsultation.appointmentsToday") ||
                    "Appointments Today"
                  : t("upcomingConsultation.appointmentToday") ||
                    "Appointment Today"}
              </h3>
              {todaysAppointments.map((appointment) => {
                const { date, time } = formatDateTime(appointment.REC_DATE);
                // Resolve display name from API profiles first, then fall back
                const profileMatch = profiles.find(
                  (p) => Number(p.ID) === Number(appointment.EMP_ID),
                );
                const description =
                  appointment.DISPLAY_NAME ||
                  (profileMatch && profileMatch.DisplayName) ||
                  empDescriptions[appointment.EMP_ID] ||
                  appointment.POSITION_NAME ||
                  "Unknown Master";

                return (
                  <li key={appointment.UID} style={styles.listItem}>
                    <button
                      style={{
                        ...styles.button,
                        ...(selectedAppointment === appointment.UID
                          ? styles.selectedButton
                          : {}),
                      }}
                      onClick={() => handleAppointmentClick(appointment.UID)}
                    >
                      <div style={styles.dateTime}>
                        <strong>
                          {t("upcomingConsultation.date") || "Date:"}
                        </strong>{" "}
                        {date} |{" "}
                        <strong>
                          {t("upcomingConsultation.time") || "Time:"}
                        </strong>{" "}
                        {time}
                      </div>
                      <div style={styles.description}>
                        <strong>
                          {t("upcomingConsultation.description") ||
                            "Description:"}
                        </strong>{" "}
                        {description}
                      </div>
                      <button
                        style={styles.meetButton}
                        onClick={() => handleMeetNowClicklocked(appointment)}
                      >
                        {t("upcomingConsultation.meetNow") || "Meet Now"}
                      </button>
                    </button>
                    {selectedAppointment === appointment.UID && (
                      <div style={styles.actionButtonsContainer}>
                        {/* <button style={styles.actionButton} onClick={() => handleChangeAppointment(appointment)}>
                        Change Appointment
                      </button> */}
                        {/* <button
                          style={styles.meetButton}
                          onClick={() => handleMeetNowClick(appointment)}
                        >
                          Meet Now
                        </button> */}
                        {/* <button
                          style={styles.meetButton}
                          onClick={() => handleMeetNowClicklocked(appointment)}
                        >
                          {t("upcomingConsultation.meetNow") ||
                            "Meet Now"}
                        </button> */}
                      </div>
                    )}
                  </li>
                );
              })}
            </>
          )}

          {/* Locked Appointments (Soon) */}
          {futureAppointments.length > 0 && (
            <>
              <h3 style={{ color: "#DFBD69" }}>
                {futureAppointments.length > 1
                  ? t("upcomingConsultation.upcomingappointments") ||
                    "Upcoming Appointments"
                  : t("upcomingConsultation.upcomingappointment") ||
                    "Upcoming Appointment"}
              </h3>
              {futureAppointments.map((appointment) => {
                const { date, time } = formatDateTime(appointment.REC_DATE);
                // Resolve display name from API profiles first, then fall back
                const profileMatch = profiles.find(
                  (p) => Number(p.ID) === Number(appointment.EMP_ID),
                );
                const description =
                  appointment.DISPLAY_NAME ||
                  (profileMatch && profileMatch.DisplayName) ||
                  empDescriptions[appointment.EMP_ID] ||
                  appointment.POSITION_NAME ||
                  "Unknown Master";

                return (
                  <li key={appointment.UID} style={styles.listItem}>
                    <button
                      style={{
                        ...styles.button,
                        ...styles.lockedButton,
                        ...(selectedAppointment === appointment.UID
                          ? styles.selectedButton
                          : {}),
                      }}
                      onClick={() => handleAppointmentClick(appointment.UID)}
                    >
                      <div style={styles.dateTime}>
                        <strong>
                          {t("upcomingConsultation.date") || "Date:"}
                        </strong>{" "}
                        {date} |{" "}
                        <strong>
                          {t("upcomingConsultation.time") || "Time:"}
                        </strong>{" "}
                        {time}
                      </div>
                      <div style={styles.description}>
                        <strong>
                          {t("upcomingConsultation.description") ||
                            "Description:"}
                        </strong>{" "}
                        {description}
                      </div>
                      <div style={styles.lockedMessage}>
                        {t("upcomingConsultation.appointmentLocked") ||
                          "Locked until the appointment day"}
                      </div>
                      <button
                        style={styles.actionButton}
                        onClick={(e) => { e.stopPropagation(); handleChangeAppointment(appointment); }}
                      >
                        {t("upcomingConsultation.changeAppointment") ||
                          "Change Appointment"}
                      </button>
                    </button>
                  </li>
                );
              })}
            </>
          )}
        </ul>
      </div>

      {isModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h2>Change Appointment</h2>
            <form onSubmit={handleSubmit}>
              <label>
                {t("upcomingConsultation.newDate") || "New Date:"}
                <input
                  type="date"
                  value={newDate}
                  onChange={(e) => setNewDate(e.target.value)}
                  required
                  style={styles.input}
                  min={today}
                />
              </label>
              <br />
              <label>
                {t("upcomingConsultation.newTime") || "New Time:"}
                <div style={{ position: "relative" }}>
                  <select
                    value={newTime}
                    onChange={async (e) => {
                      const selectedTime = e.target.value;
                      setNewTime(selectedTime);

                      // Add console log for selected time
                      console.log("Selected time:", selectedTime);

                      if (newDate && selectedAppointment && selectedTime) {
                        const formattedTime =
                          convertTo24HourFormat(selectedTime);
                        const schedDateTime = `${newDate}T${formattedTime}`; // "YYYY-MM-DDTHH:mm:ss"
                        const empId = selectedAppointment.EMP_ID;

                        // Check if slot is occupied
                        try {
                          const breResp = await fetch(
                            `https://xianhefairy.com/LotusFairy_API/api/Booking/getBRE?ID=${empId}&Date=${newDate}`,
                            {
                              method: "GET",
                              headers: { "Content-Type": "application/json" },
                            },
                          );
                          const breData = await breResp.json();
                          // breData is an array of objects with REC_DATE
                          const timeOnly = formattedTime.substring(0, 5); // "HH:mm"
                          const isOccupied = breData.some((slot) => {
                            const slotTime = new Date(slot.REC_DATE)
                              .toTimeString()
                              .substring(0, 5); // "HH:mm"
                            return slotTime === timeOnly;
                          });
                          if (isOccupied) {
                            setWarningMessage(
                              t("upcomingConsultation.warningMessage2") ||
                                "The selected time slot is already occupied. Please choose a different time.",
                            );
                            setIsWarningModalOpen(true);
                            setNewTime(""); // Reset time selection
                            return;
                          }
                        } catch (error) {
                          setWarningMessage(
                            t("upcomingConsultation.warningMessage3") ||
                              "Failed to check slot availability. Please try again.",
                          );
                          setIsWarningModalOpen(true);
                          setNewTime(""); // Reset time selection
                          return;
                        }

                        // ...existing validation logic...
                        const schedDateTimeForValidation = `${newDate} ${formattedTime.substring(0, 5)}`; // "YYYY-MM-DD HH:mm"
                        try {
                          const validateResp = await fetch(
                            `https://xianhefairy.com/LotusFairy_API/api/Booking/ValidateBooking?CustId=${ID}&bookingDate=${schedDateTimeForValidation}`,
                            {
                              method: "POST",
                              headers: {
                                "Content-Type": "application/json",
                              },
                            },
                          );
                          const validateData = await validateResp.json();
                          console.log("Validation response:", validateData);
                          if (validateData.successful) {
                            // Success: Do not show warning modal
                            return;
                          }
                          if (validateData.Message) {
                            setWarningMessage(validateData.Message);
                            setIsWarningModalOpen(true);
                            setNewTime(""); // Reset time selection
                          }
                        } catch (error) {
                          setWarningMessage(
                            t("upcomingConsultation.warningMessage4") ||
                              "Failed to validate appointment time. Please try again.",
                          );
                          setIsWarningModalOpen(true);
                          setNewTime(""); // Reset time selection
                        }
                      }
                    }}
                    required
                    style={styles.input}
                  >
                    {timeSlots.map((slot, index) => {
                      const startHour = slot.start.hour % 12 || 12;
                      const endHour = slot.end.hour % 12 || 12;
                      const startPeriod = slot.start.hour >= 12 ? "PM" : "AM";
                      const endPeriod = slot.end.hour >= 12 ? "PM" : "AM";
                      const startTime = `${startHour}:${slot.start.minute
                        .toString()
                        .padStart(2, "0")} ${startPeriod}`;
                      const endTime = `${endHour}:${slot.end.minute
                        .toString()
                        .padStart(2, "0")} ${endPeriod}`;
                      return (
                        <option key={index} value={startTime}>
                          {startTime} - {endTime}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </label>
              <br />
              <button type="submit" style={styles.submitButton}>
                {t("upcomingConsultation.submit") || "Submit"}
              </button>
              <button
                type="button"
                style={styles.cancelButton}
                onClick={handleModalClose}
              >
                {t("upcomingConsultation.cancel") || "Cancel"}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Warning Modal */}
      {isWarningModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h2>{t("upcomingConsultation.warning") || "Warning"}</h2>
            <p>{warningMessage}</p>
            <button onClick={handleWarningModalClose} style={styles.okButton}>
              {t("upcomingConsultation.ok") || "OK"}
            </button>
          </div>
        </div>
      )}

      {isWaitingLobbyOpen && (
        <div style={styles.waitingoverlay}>
          <div style={styles.waitingmodal}>
            <h2 className="text-xl font-bold mb-4">
              {t("upcomingConsultation.waitingLobby") || "Waiting Lobby"}
            </h2>
            <p>{waitingMessage}</p>
            <button
              className="mt-4 bg-red-500 text-black px-4 py-2 rounded"
              onClick={cancelWaiting}
            >
              {t("upcomingConsultation.cancelWaiting") || "Cancel Waiting"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  waitingoverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  waitingmodal: {
    backgroundColor: "white",
    padding: "2rem 3rem",
    borderRadius: "10px",
    boxShadow: "0 2px 15px rgba(0,0,0,0.3)",
    textAlign: "center",
    maxWidth: "400px",
    width: "80%",
  },
  container: {
    maxWidth: "100vw",
    // margin: "0 auto",
    padding: "30px",
    backgroundColor: "transparent",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  },
  header: {
    textAlign: "center",
    color: "#DFBD69",
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: "40px",
    //fontFamily: "Arial, sans-serif",
  },
  listContainer: {
    height: "80vh",
    overflowY: "auto", // Enable vertical scrolling
    paddingRight: "10px", // Space for scrollbar
  },
  list: {
    listStyleType: "none",
    padding: 0,
  },
  listItem: {
    marginBottom: "15px",
  },
  button: {
    width: "100%",
    padding: "20px",
    backgroundColor: "#dfbd69",
    color: "#DFBD69",
    border: "1px solid #ddd",
    borderRadius: "10px",
    cursor: "pointer",
    textAlign: "left",
    transition: "all 0.3s ease",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    fontFamily: "Arial, sans-serif",
  },
  selectedButton: {
    backgroundColor: "#DFBD69",
    borderColor: "white",
  },
  actionButtonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
  },
  actionButton: {
    backgroundColor: "#DFBD69",
    color: "#000",
    padding: "10px 20px",
    // border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    fontFamily: "Arial, sans-serif",
    width: "fit-content",
    fontSize: "16px",
    borderColor: "#000",
    display: "block",
    margin: "10px auto 0",
  },
  meetButton: {
    backgroundColor: "#DFBD69",
    color: "#000",
    padding: "10px 20px",
    // border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    width: "fit-content",
    fontSize: "16px",
    display: "block",
    margin: "10px auto 0",
    borderColor: "#000",
    borderWidth: "1px",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContent: {
    backgroundColor: "#212121",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    width: "20%",
    color: "#dfbd69",
  },
  input: {
    width: "100%",
    padding: "8px",
    margin: "10px 0",
    border: "1px solid #ddd",
    borderRadius: "4px",
  },
  submitButton: {
    backgroundColor: "#DFBD69",
    color: "#212121",
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
  },
  cancelButton: {
    backgroundColor: "#dc3545",
    color: "#212121",
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    marginLeft: "10px",
    fontSize: "16px",
  },
  okButton: {
    backgroundColor: "#DFBD69",
    color: "black",
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },
  dateTime: {
    fontSize: "16px",
    color: "black",
  },
  description: {
    fontSize: "14px",
    color: "black",
  },
  lockedMessage: {
    fontSize: "12px",
    color: "red",
    marginTop: "5px",
  },
};

export default AppointmentPage;
